export default __webpack_public_path__ + "static/Pattern5-07747aa0e211d88923d994aac76d81b7.png";